// We should try refreshing the session if there exists a cached session in
// state that might be stale. Otherwise, we know there is no session, so there's
// no need.
const shouldTryRefresh = (state)=>!!state?.session;

export { shouldTryRefresh };
//# sourceMappingURL=shouldTryRefresh.mjs.map
